/* eslint-disable no-multi-spaces */
import { fromJS } from 'immutable';
import React from 'react';
import { dispatch } from 'nike-re-framejs';

import { PopupButton } from '@/common/components/Button';
import { Popup } from './Popup';
import i18n from '@i18n';
import { isString } from '@/common/util';
import PopupNg from '@/ui/PopupNg';
import { interceptAnchorClickEvent } from 'nike-ui/src/components/link-interceptor/LinkInterceptor';

const closePopupVector = ['ui.popup/ng', null];

export function build(data) {
    let merge = data;
    if (Object.prototype.toString.call(data) === '[object Array]' || typeof data === 'string') {
        merge = { messages: data };
    }
    const obj = Object.assign(
        {
            messages: [],
            buttons: [],
            close: [],
            backdropAction: [],
            style: '',
            htmlMessages: false
        },
        merge
    );
    obj.messages = isString(obj.messages) ? [obj.messages] : obj.messages;
    obj.buttons = isString(obj.buttons[0]) ? [obj.buttons] : obj.buttons;
    obj.close = isString(obj.close[0]) ? [obj.close] : obj.close;
    obj.backdropAction = isString(obj.backdropAction[0]) ? [obj.backdropAction] : obj.backdropAction;

    if (obj.buttons.length === 0 && obj.close.length === 0) {
        obj.close.push(closePopupVector);
        obj.backdropAction.push(closePopupVector);
    }
    return fromJS(obj);
}

function MessagesPopup({ popupData }) {
    function fireActions(actions) {
        actions.forEach(dispatch);
    }

    function fireActionsAndClose(actions) {
        fireActions(actions);
        const alreadyHaveCloseVector = actions.filter(
            action => action[0] === closePopupVector[0] && action[1] === closePopupVector[1]
        ).length;
        if (!alreadyHaveCloseVector) {
            dispatch(closePopupVector);
        }
    }

    function intercept(event) {
        const intercepted = interceptAnchorClickEvent(event);
        if (intercepted) {
            dispatch(closePopupVector);
        }
    }

    return (
        <Popup className={popupData.get('style')} onClose={() => fireActions(popupData.get('backdropAction').toJS())}>
            {popupData.get('title') ? <h1 className="icon">{i18n(popupData.get('title'))}</h1> : null}
            <ul onClick={popupData.get('htmlMessages') ? intercept : null}>
                {popupData.get('messages').map((item, index) => {
                    return popupData.get('htmlMessages') ? (
                        <li key={'m' + index} dangerouslySetInnerHTML={{ __html: i18n(item) }} />
                    ) : (
                        <li key={'m' + index}>{i18n(item)}</li>
                    );
                })}
            </ul>
            <div className="actions">
                {popupData.get('close').size ? (
                    <PopupButton
                        onClick={() => fireActionsAndClose(popupData.get('close').toJS())}
                        i18nCode="jsp.message.zavriet"
                    />
                ) : null}
                {popupData.get('buttons').map((button, index) => {
                    return (
                        <PopupButton
                            key={index}
                            onClick={() => fireActionsAndClose(button.rest().toJS())}
                            i18nCode={button.get(0)}
                        />
                    );
                })}
            </div>
        </Popup>
    );
}

PopupNg.dispatcher.show = (data, priority = 1) => PopupNg.dispatcher.open('ui/message', build(data), priority);
PopupNg.updater.show = (data, priority = 1) => PopupNg.updater.open('ui/message', build(data), priority);

export default MessagesPopup;
